import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { UserFeedbackForm } from "../../pages/userFeedback/UserFeedbackForm";
import { Button, Dialog, Slide, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./HelpNavigationModal.module.scss";
import AlertDialog from "../AlertDialog";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiIconButton-label": {
      alignItems: "unset",
    }
  },
}));
export default function HelpNavigationModal({
  shouldShowModal,
  setShouldShowModal,
  modalComponentID,
}) {
  const classes = useStyles();
  const [closeReminder, setCloseReminder] = useState(false);
  const handleClickClose = () => {
    // setShouldShowModal(prevState => !prevState);
    setCloseReminder(true);
  };
  const handleCancelRequest = () => {
    setCloseReminder(false);
    setShouldShowModal(false);
  };
  return (
    <Dialog
      fullScreen
      className={classes.root}
      open={shouldShowModal}
      onClose={handleClickClose}
      TransitionComponent={Transition}
    >
      <AlertDialog
        open={closeReminder}
        onClose={() => {
          setCloseReminder(false);
        }}
        title={`Are you sure you want to end the survey?`}
        body={<p>Just a reminder that your response won't be saved.</p>}
        footer={
          <div
            className={styles.closeModalContainer}
          >
            <div
              className={styles.closeCancelButton}
              onClick={() => {
                setCloseReminder(false);
              }}
            >
              {"Cancel"}
            </div>
            <Button
              style={{
                padding: "8px",
                color: "white",
                backgroundColor: "#E35646",
                fontSize: "14px",
                fontWeight: 500,
                width: "40%",
                cursor: "pointer",
              }}
              onClick={handleCancelRequest}
            >
              {"Yes, I am sure"}
            </Button>
          </div>
        }
      />
      <div className={styles.closeContainer}>
        <IconButton
          onClick={handleClickClose}
          className={styles.closeIcon}
          aria-label="open help dropdown navigation"
        >
          <CloseIcon className={styles.closeIcon} fontSize="medium" />
          <p className={styles.closeLabel}>Close</p>
        </IconButton>
      </div>

      {modalComponentID === "User Feedback Survey" && <UserFeedbackForm />}
    </Dialog>
  );
}
